import React from "react";
import { Link } from "react-router-dom";
import { useSiteSettings } from "@/lib/settings";
import { resolveImage } from "@/lib/api";

// Height presets keep the logo well-proportioned across viewports.
const SIZE_HEIGHTS = {
  sm: "h-7",
  md: "h-9 sm:h-10",
  lg: "h-14 sm:h-16",
  xl: "h-20 sm:h-24",
};

const TEXT_SIZES = {
  sm: { cn: "text-xl", en: "text-[9px]" },
  md: { cn: "text-2xl", en: "text-[10px]" },
  lg: { cn: "text-4xl", en: "text-xs" },
  xl: { cn: "text-6xl md:text-7xl", en: "text-sm" },
};

export default function Logo({ size = "md", className = "", light = false }) {
  const settings = useSiteSettings();
  const src = settings?.logo_path ? resolveImage(settings.logo_path) : null;

  // Image logo — the artwork is black. On teal surfaces (light=true) wrap in a
  // white rounded pill so the mark stays legible.
  if (src) {
    const img = (
      <img
        src={src}
        alt="JinLin Creative 晶灵文创"
        className={`${SIZE_HEIGHTS[size] || SIZE_HEIGHTS.md} w-auto object-contain`}
        data-testid="site-logo-img"
      />
    );
    return (
      <Link to="/" className={`inline-flex items-center ${className}`} data-testid="site-logo">
        {light ? (
          <span className="inline-flex items-center rounded-full bg-white px-4 py-1.5 shadow-sm">
            {img}
          </span>
        ) : (
          img
        )}
      </Link>
    );
  }

  // Fallback: text-based logo (matches the user's real logo spirit)
  const s = TEXT_SIZES[size] || TEXT_SIZES.md;
  const color = light ? "text-white" : "text-[#003645]";
  return (
    <Link
      to="/"
      className={`inline-flex flex-col items-start leading-none ${className}`}
      data-testid="site-logo"
    >
      <span
        className={`logo-cn ${s.cn} ${color}`}
        style={{ fontWeight: 900, letterSpacing: "-0.02em" }}
      >
        晶灵文创
      </span>
      <span
        className={`mt-1 ${s.en} tracking-[0.28em] font-semibold ${
          light ? "text-white/70" : "text-[#00868e]"
        }`}
      >
        JINLIN CREATIVE
      </span>
    </Link>
  );
}
